<template>
    <div v-if="res.message" class="flex items-center bg-red-300 text-red-900 text-sm rounded-lg p-3 mb-8 font-semibold" :class="addtl">
        {{res.message}}
        <font-awesome-icon @click="res.message = ''" :icon="['far', 'xmark']" class="ml-auto text-xl cursor-pointer" />
    </div>
</template>
<script setup>
const props = defineProps({
    res: Object,
    addtl: String
})
</script>
